var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$t('label.vehicle')}},[_c('canvas',{ref:"canvas",attrs:{"width":"900","height":"400"}})])}
var staticRenderFns = []

export { render, staticRenderFns }